import React from 'react';
import { MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { globalHistory, Router } from '@reach/router';

// import theme from './themes/dim-yellow';
import theme from './themes/friendly-green';
import DashboardPage from './views/DashboardPage';
import SignInPage from './views/SignInPage/index';
import PublicRoute from './components/PublicRoute';
import PrivateRoute from './components/PrivateRoute';
import { ApolloProvider as ApolloHooksProvider } from 'react-apollo-hooks';
import { ApolloProvider } from 'react-apollo';
import LuxonUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Provider as UserProvider } from './contexts/UserContext';
import { client } from './common/apollo';
import schema from './graphql/schema.json';
import { AmplifyModelProvider } from 'amplify-model-react';
import { QueryParamProvider } from 'use-query-params';
import { SnackbarProvider } from 'notistack';
import Amplify from 'aws-amplify';
import { AWSIoTProvider } from '@aws-amplify/pubsub/lib/Providers';

Amplify.addPluggable(
  new AWSIoTProvider({
    aws_pubsub_region: 'ap-southeast-2',
    aws_pubsub_endpoint: 'wss://a18gcgqs7zx061-ats.iot.ap-southeast-2.amazonaws.com/mqtt'
  })
);

const appStyles = theme => ({
  root: { ...theme.typography }
});

const Wrapper = withStyles(appStyles, { withTheme: true })(({ classes }) => (
  <div className={classes.root}>
    <Router>
      <PublicRoute path="/sign-in" component={SignInPage} />
      <PrivateRoute path="/*" component={DashboardPage} />
    </Router>
  </div>
));

function App() {
  return (
    <ApolloProvider client={client}>
      <ApolloHooksProvider client={client}>
        <MuiThemeProvider theme={theme}>
          <MuiPickersUtilsProvider utils={LuxonUtils}>
            <QueryParamProvider reachHistory={globalHistory}>
              <AmplifyModelProvider schema={schema}>
                <CssBaseline />
                <SnackbarProvider
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
                  <UserProvider>
                    <Wrapper />
                  </UserProvider>
                </SnackbarProvider>
              </AmplifyModelProvider>
            </QueryParamProvider>
          </MuiPickersUtilsProvider>
        </MuiThemeProvider>
      </ApolloHooksProvider>
    </ApolloProvider>
  );
}

export default App;
